import { Chip, SxProps, Theme } from '@mui/material'
import { CSSProperties } from 'react'

export interface IStatusProps {
  status: string,
  color?: string,
  bgcolor?: string,
  tooltip?: string,
  fontSize?: number,
  height?: number | string,
  borderRadius?: number | string,
  style?: CSSProperties,
  sx?: SxProps<Theme>
}

const Status = ({ status, color, bgcolor, fontSize, height, borderRadius, style, sx }: IStatusProps) => {
  return (
    <Chip
      size="small"
      label={status.toString()}
      style={style}
      sx={{
        borderRadius: borderRadius ?? 1,
        height: height ?? '20px',
        minHeight: height ?? '20px',
        backgroundColor: bgcolor ?? 'grey.700',
        color: color ?? 'common.white',
        fontWeight: 500,
        fontSize: fontSize ?? 10,
        alignSelf: 'center',
        padding: '0 8px',
        '.MuiChip-label': {
          padding: 0,
          lineHeight: `${height ?? 20}px`,
        },
        ...sx
      }}
    />
  )
}

export default Status;
